import React, { useState } from "react";
import { EditOutlined } from "@ant-design/icons";
import PositionEditForm from "./PositionEditForm";
import ActionsModal from "../../common/components/ActionsModal";
import { useMutation } from "react-query";
import { AxiosPositionsAPI } from "../Api";
import { Form } from "antd";
import moment from "moment";
import {
  onError,
  onSuccess,
} from "../../common/components/AreasPositions/RequestSolvers";

const PositionEditAction = ({ position, reload }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();

  const { mutate } = useMutation(
    ["editPosition"],
    AxiosPositionsAPI.editPosition,
    {
      onError: (error) =>
        onError(
          error,
          ["code", "end_date"],
          "Não foi possível realizar a solicitação de edição do cargo!",
        ),
      onSuccess: () =>
        onSuccess(
          reload,
          form,
          () => setIsModalOpen(false),
          "Cargo editado com sucesso!",
        ),
    },
  );
  const editPosition = (values) => {
    mutate({
      ...values,
      seniority_level: values.seniority_level ?? null,
      start_date: moment(values.start_date).format("YYYY-MM-DD"),
      end_date: values.end_date
        ? moment(values.end_date).format("YYYY-MM-DD")
        : undefined,
      id: position.id,
    });
  };
  return (
    <ActionsModal
      isModalOpen={isModalOpen}
      setIsModalOpen={setIsModalOpen}
      onSubmit={editPosition}
      form={form}
      button={<EditOutlined onClick={() => setIsModalOpen(true)} />}
      context={`Editar ${position.name}`}
    >
      <PositionEditForm form={form} position={position} />
    </ActionsModal>
  );
};

export default PositionEditAction;
